<template>
	<div class="mb-2 p-4 sm:p-0" v-if="meetingid === score.meeting.id">

		<results :results="score.results" v-if="Object.keys(score.results).length" />

		<div class="flex" v-else>
			There are no results for this meeting yet.
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			score: {
				type: Object,
				default: {}
			},
            meetingid: {
				type: Number,
				default: {}
			}
		}
	}
</script>
